/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core'

declare const FlipDown: any

@Component({
  selector: 'flipdown-timer',
  imports: [],
  standalone: true,
  templateUrl: './flipdown-timer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FlipdownTimerComponent {
  text = input<string>(
    'el catálogo de premios que estabas esperando. Estamos ultimando detalles para que puedas canjear tus puntos por premios espectaculares.'
  )

  date = input<number>()

  init() {
    const flipdown = new FlipDown(this.date(), {
      theme: 'custom',
      headings: ['Días', 'Horas', 'Minutos', 'Segundos']
    })

    flipdown.start()
  }
}
